// import React from "react";
// import Tiles from "./Tiles";
// import Navbar1 from "./Navbar";
// import Header from "./Header";
// function Landing()
// {
//     return(
//         <>
//         <Header/>
//         <Navbar1/>
//         <Tiles/>
//         </>
//     );
// }
// export default Landing

// import React, { useState, useEffect } from "react";
// import Tiles from "./Tiles";
// import Navbar1 from "./Navbar";
// import Header from "./Header";
// import Payment from "./Payment"; // ✅ Import Payment component
// import { useUser } from "./context/UserContext"; // ✅ Import user context

// function Landing() {
//   const { loggedInUser } = useUser();
//   const [showPayment, setShowPayment] = useState(false);

//   useEffect(() => {
//     // ✅ Check dial_cnt from localStorage when Landing loads
//     const dialCntUser = parseInt(localStorage.getItem(`dial_cnt_${loggedInUser}`) || "0", 10);
//     const dialCntGeneric = parseInt(localStorage.getItem("dial_cnt") || "0", 10);

//     // ✅ Take the maximum of both values to be safe
//     const dialCnt = Math.max(dialCntUser, dialCntGeneric);

//     console.log("Landing dial_cnt check:", dialCnt);

//     // ✅ Show payment popup ONLY if dial_cnt is 0 (first-time user)
//     if (dialCnt === 0) {
//       setShowPayment(true);
//     }
//   }, [loggedInUser]);

//   const handlePaymentClose = () => {
//     setShowPayment(false); // ✅ Close popup when user dismisses
//   };

//   const handlePaymentSuccess = async () => {
//     setShowPayment(false); // ✅ Close popup after successful payment
//   };

//   return (
//     <>
//       <Header />
//       <Navbar1 />
//       <Tiles />

//       {/* ✅ Payment popup — shows only when dial_cnt === 0 */}
//       {showPayment && (
//         <Payment
//           show={showPayment}
//           handleClose={handlePaymentClose}
//           onPaymentSuccess={handlePaymentSuccess}
//           currentRemainingBalance={0}
//         />
//       )}
//     </>
//   );
// }

// export default Landing;

// import React, { useState, useEffect } from "react";
// import Tiles from "./Tiles";
// import Navbar1 from "./Navbar";
// import Header from "./Header";
// import Payment from "./Payment"; 
// import { useUser } from "./context/UserContext"; 

// function Landing() {
//   const { loggedInUser } = useUser();
//   const [showPayment, setShowPayment] = useState(false);

//   useEffect(() => {
//     // 1. Check if the user already has an active subscription
//     const isSubscribed = localStorage.getItem("isSubscribed") === "true";

//     // 2. Check the dial count
//     const dialCntUser = parseInt(localStorage.getItem(`dial_cnt_${loggedInUser}`) || "0", 10);
//     const dialCntGeneric = parseInt(localStorage.getItem("dial_cnt") || "0", 10);
//     const dialCnt = Math.max(dialCntUser, dialCntGeneric);

//     // 3. Check if they have already seen the popup this session
//     const hasSeenPopup = sessionStorage.getItem("hasSeenPaymentPopup") === "true";

//     // ✅ Show payment popup ONLY if they haven't purchased AND haven't seen it yet
//     if (!isSubscribed && dialCnt === 0 && !hasSeenPopup) {
//       setShowPayment(true);
//       // ✅ Mark that they have seen it, so it won't show again on re-renders
//       sessionStorage.setItem("hasSeenPaymentPopup", "true");
//     }
//   }, [loggedInUser]);

//   const handlePaymentClose = () => {
//     setShowPayment(false); 
//   };

//   const handlePaymentSuccess = async () => {
//     // Update local storage so the system knows they are now subscribed
//     localStorage.setItem("isSubscribed", "true");
//     setShowPayment(false); 
//   };

//   return (
//     <>
//       <Header />
//       <Navbar1 />
//       <Tiles />

//       {showPayment && (
//         <Payment
//           show={showPayment}
//           handleClose={handlePaymentClose}
//           onPaymentSuccess={handlePaymentSuccess}
//           currentRemainingBalance={0}
//         />
//       )}
//     </>
//   );
// }

// export default Landing;

import React, { useState, useEffect } from "react";
import Tiles from "./Tiles";
import Navbar1 from "./Navbar";
import Header from "./Header";
import Payment from "./Payment"; 
import { useUser } from "./context/UserContext"; 
import axios from "axios";
import { getBaseUrl } from "../api";

function Landing() {
  const { loggedInUser } = useUser();
  const [showPayment, setShowPayment] = useState(false);
  const [hasPayments, setHasPayments] = useState(false);
  const [loading, setLoading] = useState(true);
  const baseUrl = getBaseUrl();

  useEffect(() => {
    checkUserPaymentHistory();
  }, [loggedInUser]);

  const checkUserPaymentHistory = async () => {
    try {
      setLoading(true);
      const user_id = localStorage.getItem("user_id");
      
      if (!user_id || !loggedInUser) {
        setLoading(false);
        return;
      }

      // Fetch user's payment history from backend
      const response = await axios.post(`https://${baseUrl}/request`, {
        action: "R",
        object: "payments",
        user_id: user_id,
        status: "Success"
      });

      let hasAnyPayment = false;
      
      if (response.data && response.data.response && response.data.response.length > 0) {
        // Check if there are any successful payments
        const payments = response.data.response;
        hasAnyPayment = payments.length > 0;
        setHasPayments(hasAnyPayment);
      }

      // Check if they have already seen the popup this session
      const hasSeenPopup = sessionStorage.getItem("hasSeenPaymentPopup") === "true";

      // ✅ Show payment popup ONLY if they have NO payment history AND haven't seen it yet
      if (!hasAnyPayment && !hasSeenPopup) {
        setShowPayment(true);
        // ✅ Mark that they have seen it, so it won't show again on re-renders
        sessionStorage.setItem("hasSeenPaymentPopup", "true");
      }
      
    } catch (error) {
      console.error("Error checking payment history:", error);
      // In case of error, default to checking localStorage as fallback
      const isSubscribed = localStorage.getItem("isSubscribed") === "true";
      const hasSeenPopup = sessionStorage.getItem("hasSeenPaymentPopup") === "true";
      
      if (!isSubscribed && !hasSeenPopup) {
        setShowPayment(true);
        sessionStorage.setItem("hasSeenPaymentPopup", "true");
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentClose = () => {
    setShowPayment(false); 
  };

  const handlePaymentSuccess = async () => {
    // Update local storage so the system knows they are now subscribed
    localStorage.setItem("isSubscribed", "true");
    setHasPayments(true);
    setShowPayment(false); 
  };

  return (
    <>
      <Header />
      <Navbar1 />
      <Tiles />

      {!loading && showPayment && (
        <Payment
          show={showPayment}
          handleClose={handlePaymentClose}
          onPaymentSuccess={handlePaymentSuccess}
          currentRemainingBalance={0}
        />
      )}
    </>
  );
}

export default Landing;